import { Box, Grid, Typography, useTheme } from "@mui/material";
import LoginImage from "../../../../../media/images/LoginImage.png";

import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import { changeSignupType } from "../../../../../redux/features/settingSlice";
import ArrowRightSVG from "../../../../../media/images/icons/arrow-right";
import MobileHeader from "../../../../layout/AuthLayout/MobileHeader";
import AuthFooter from "../../../../layout/AuthLayout/Footer";
import CompanySignup from "../CompanySignup";
import LogoImage from "../../../../../media/images/icons/logo.svg";
import FormSteps from "../CompanySignup/Steps";
import LoginLink from "../LoginLink";
export default function UserSignupGrid() {
  const appDispatch = useAppDispatch();
  const theme = useTheme();

  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader title="ثبت نام شرکت حمل و نقل" hasScroll={hasScroll} />
      <Box
        ref={divRef}
        sx={{
          flex: 1,
          // border: "4px solid green",
          overflowY: "auto",
        }}
      >
        <Grid
          container
          sx={{
            height: "100%",
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{
              // border: "5px solid gray",
              backgroundImage: `url(${LoginImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              display: {
                xs: "none",
                md: "flex",
              },
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
                paddingY: "16px",
                paddingX: "10px",
                position: "relative",
                maxWidth: {
                  xl: "45%",
                  lg: "65%",
                  md: "80%",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  backgroundColor: "background.default",
                  opacity: "0.9",
                  borderRadius: "16px",
                }}
              ></Box>
              <Box
                sx={{
                  position: "relative",
                }}
              >
                <img width={70} src={LogoImage} alt="" />
                <Typography
                  sx={{
                    fontWeight: "900",
                    zIndex: 5,
                  }}
                  variant="h2"
                  color="primary.main"
                >
                  {"ثبت‌نام صاحبین بار و رانندگان"}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "800",
                    color: "textColor.dark",
                    marginTop: "14px",
                  }}
                >
                  {
                    "صاحبین بار و رانندگان برای ثبت‌نام در بازارگاه از این قسمت وارد شوند."
                  }
                </Typography>
                <CustomButton
                  justifyContent="space-between"
                  flexDirection="row-reverse"
                  onClick={() => appDispatch(changeSignupType())}
                  title="ثبت‌نام صاحبین بار و رانندگان"
                  bgColor="primary.main"
                  width="100%"
                  fSize="16px"
                  fontWeight={500}
                  px="10px"
                  py="12px"
                  borderRadius="10px"
                  color="lightStatic.main"
                  icon2={<ArrowRightSVG size={32} />}
                  mt="16px"
                />
              </Box>
            </Box>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "12px",
              paddingX: {
                xs: "8px",
              },
            }}
            xs
            sm
            md={8}
            lg={8}
            item
          >
            <Box
              sx={{
                width: "100%",
                flex: 1,
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: "16px",
              }}
            >
              <Box
                sx={{
                  marginX: "auto",
                  width: {
                    xl: "40%",
                    lg: "60%",
                    md: "80%",
                    xs: "100%",
                  },
                }}
              >
                {/* <Box
                  sx={{
                    mb: "16px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: {
                      xs: "flex",
                      md: "none",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                    }}
                    color={"primary.main"}
                  >
                    ثبت‌نام شرکت حمل و نقل
                  </Typography>

                  <Typography
                    onClick={() => appDispatch(changeSignupType())}
                    color={"secondary.main"}
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    راننده یا صاحب کالا هستید؟
                  </Typography>
                </Box> */}
                <FormSteps />
                <CompanySignup />
                <LoginLink />
              </Box>
            </Box>
            <AuthFooter />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
